import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBjUYZz7Y7kXCrvSY2qb4bQEO_qiqD4gys", // Replace with your actual API KEY from .env
  authDomain: "diyai.vercel.app", // Replace with actual Auth Domain
  projectId: "diy-ai-f481d" // Replace with actual Project ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export { auth };
